import { Carousel, pluralize } from '@leland-dev/leland-ui-library';
import Image from 'next/image';
import { type FC } from 'react';
import { Autoplay } from 'swiper/modules';

import { type WinWallMarqueeOrganizationOutcomeSummaryFragment } from './__generated-gql-types__/WinWallMarquee.generated';

interface WinWallMarqueeProps {
  reverse?: boolean;
  outcomes: WinWallMarqueeOrganizationOutcomeSummaryFragment[];
}
export const WinWallMarquee: FC<WinWallMarqueeProps> = ({
  reverse,
  outcomes,
}) => {
  return (
    <Carousel
      hideControls
      swiperProps={{
        wrapperClass: 'transition-all duration-1000 ease-linear',
        speed: 8000,
        spaceBetween: 20,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        loop: true,
        autoplay: {
          delay: 0,
          reverseDirection: reverse,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        },
        preventInteractionOnTransition: true,
        modules: [Autoplay],
      }}
      items={outcomes.map((outcome, index) => {
        return <MarqueeItem outcome={outcome} key={index} />;
      })}
    />
  );
};

interface MarqueeItemProps {
  outcome: WinWallMarqueeOrganizationOutcomeSummaryFragment;
}
const MarqueeItem: FC<MarqueeItemProps> = ({ outcome }) => {
  const subText =
    outcome.organization?.__typename === 'Company'
      ? `${pluralize(outcome.count, 'job')} landed`
      : pluralize(outcome.count, 'admission');
  return (
    <div className="flex items-center gap-2 rounded-full border bg-white py-2 pl-3 pr-8">
      {outcome.organization.logoLink ? (
        <Image
          className="size-10 shrink-0 rounded-full object-contain"
          width={40}
          height={40}
          src={outcome.organization.logoLink}
          alt={outcome.organization.name}
        />
      ) : null}
      <div className="flex flex-col items-start">
        <span className="max-w-48 truncate font-medium leading-5">
          {outcome.organization?.name}
        </span>
        <span className="leading-5">{subText}</span>
      </div>
    </div>
  );
};
